import { call, put, takeEvery, select } from "redux-saga/effects"

import {
  GET_BUSINESS_COLOR_PALETTES,
  GET_PUBLIC_COLOR_PALETTES,
  GET_COLOR_PALETTE,
  POST_COLOR_PALETTE,
  PATCH_COLOR_PALETTE,
  DELETE_COLOR_PALETTE,
} from "Containers/ColorPalettes/types"

import {
  getBusinessColorPalettesAction,
  getBusinessColorPalettesSuccessAction,
  getPublicColorPalettesSuccessAction,
  getSingleColorPaletteSuccessAction,
  postColorPaletteSuccessAction,
} from "Containers/ColorPalettes/actions"

import {
  setSuccessMessage,
  setErrorMessage,
  removeErrorMessage,
  removeSuccessMessage,
} from "Containers/Messages/actions"

import { selectCurrentToken } from "Containers/Login/selectors"

import { selectBusinessId } from "Containers/BusinessInformations/selectors"

// Utils

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  responseTypeIsWarning,
  manageErrorGenerator,
  manageSuccessGenerator,
  manageWarningGenerator,
} from "Containers/App/saga"
import { config } from "Utils/config"
const { API_URL } = config
import request from "Utils/request"
import { postCors, getCors, patchCors, deleteCors } from "Utils/rulesCors"

// ***************************** //
//        ColorPalettes          //
// ***************************** //
function* getBusinessColorPalettes() {
  const token = yield select(selectCurrentToken)
  const businessId = yield select(selectBusinessId)
  const specificHeaders = { token: token }
  const requestURL = `${API_URL}/colorPalettes/business/${businessId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getBusinessColorPalettesSuccessAction(response))
    }
  } catch (err) {
    console.error("[route] => /colorPalettes/business/:_businessId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* getPublicColorPalettes() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const requestURL = `${API_URL}/colorPalettes/public`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getPublicColorPalettesSuccessAction(response))
    }
  } catch (err) {
    console.error("[route] => /colorPalettes/public => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* getSingleColorPalette({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const requestURL = `${API_URL}/colorPalette/${payload._idPalette}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getSingleColorPaletteSuccessAction(response))
    }
  } catch (err) {
    console.error("[route] => /colorPalette/:_idPalette => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* postColorPalette({ payload }) {
  const token = yield select(selectCurrentToken)
  const businessId = yield select(selectBusinessId)
  const specificHeaders = { token: token }
  const requestURL = `${API_URL}/colorPalette`

  try {
    const response = yield call(
      request,
      requestURL,
      postCors({ idBusiness: businessId, ...payload.paletteToCreate }, specificHeaders)
    )
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(postColorPaletteSuccessAction(response))
      yield put(getBusinessColorPalettesAction())
    }
  } catch (err) {
    console.error("[route] => /colorPalette => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* patchColorPalette({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const requestURL = `${API_URL}/colorPalette/${payload._idPalette}`

  try {
    const response = yield call(
      request,
      requestURL,
      patchCors({ ...payload.paletteToUpdate }, specificHeaders)
    )
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getBusinessColorPalettesAction())
    }
  } catch (err) {
    console.error("[route] => /colorPalette/:_idPalette => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* deleteColorPalette({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const requestURL = `${API_URL}/colorPalette/${payload._idPalette}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getBusinessColorPalettesAction())
    }
  } catch (err) {
    console.error("[route] => /colorPalette/:_idPalette => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// ***************************** //
//              Sagas            //
// ***************************** //
function* colorPalettesSaga() {
  yield takeEvery(GET_BUSINESS_COLOR_PALETTES, getBusinessColorPalettes)
  yield takeEvery(GET_PUBLIC_COLOR_PALETTES, getPublicColorPalettes)
  yield takeEvery(GET_COLOR_PALETTE, getSingleColorPalette)
  yield takeEvery(POST_COLOR_PALETTE, postColorPalette)
  yield takeEvery(PATCH_COLOR_PALETTE, patchColorPalette)
  yield takeEvery(DELETE_COLOR_PALETTE, deleteColorPalette)
}

export default colorPalettesSaga
